import React, { useEffect, useRef, useState } from 'react';
import { Loader } from '@googlemaps/js-api-loader';

const Map = ({ onPlaceSelected, setMapInstance }) => {
  const [map, setMap] = useState(null);
  const mapRef = useRef(null);
  const apiKey =  "AIzaSyCYTg9ZiSN0BC4OgESRr94yiT6reKF27f8";

  useEffect(() => {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    script.onload = () => {
      const options = {
        zoom: 10,
      };
      const map = new window.google.maps.Map(mapRef.current, options);
      setMap(map);
      setMapInstance(map);
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            const pos = { lat: latitude, lng: longitude };
            map.setCenter(pos);
          },
          () => {
            console.error('Error: The Geolocation service failed.');
          }
        );
      } else {
        console.error('Error: Your browser doesn\'t support geolocation.');
      }
    };
    document.head.appendChild(script);
  }, []);

  return (
    <div
      ref={mapRef}
      style={{ height: '100vh', width: '100%', margin: 0, padding: 0 }}
    ></div>
  );
};
  
export default Map;
